module.exports = __webpack_public_path__ + "img/vipjf888.93cbf0a1.png";